export default __webpack_public_path__ + "static/media/Power_Privilege.e5171959.png";